// This will prevent authenticated users from accessing this route
import { useSelector } from "react-redux"
import { Navigate } from "react-router-dom"


function OpenRoute({ children }) {
  
  const { token } = useSelector((state) => state.auth)
  const accountType = useSelector((state)=> state?.profile?.user?.accountType)
    
  
  
  if (token === null) {
    return children
  } else {
      if (accountType === "SuperAdmin"){
        return <Navigate to="/super-dashboard" />
      }
      else if (accountType === "Admin"){
        return <Navigate to="/admin-dashboard" />
      }
      else if (accountType === "Employee"){
        return <Navigate to="/user-dashboard" />
      }
      else {
        
          return <Navigate to="/features" />
        
      }
    // return <Navigate to="/dashboard/my-profile" />
  }
}

export default OpenRoute